var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c("page-loading-spinner", {
        attrs: {
          "is-initial-loading": false,
          "is-refresh-loading": _vm.isRefreshLoading,
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary w-100",
          attrs: {
            "aria-label": _vm.offerNameAccessibility,
            "data-oevent-category": _vm.trackingCategory,
            "data-oevent-action": _vm.formattedTrackingAction,
            "data-oevent-label": _vm.trackingLabel,
          },
          on: { click: _vm.handleAddToCart },
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("with-device-popin", {
            attrs: {
              id: _vm.popinId,
              "with-device-section": _vm.popinCtasDto.withDeviceSection,
              "without-device-section": _vm.popinCtasDto.withoutDeviceSection,
              title: _vm.popinCtasDto.title,
              description: _vm.popinCtasDto.description,
              visual: _vm.popinCtasDto.visual,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }